import React from 'react';
import './DisplayPrinterType.css';
import { t } from 'i18next';
import PlusCircleIcon from '../../../../assets/images/hardware-inclusive/plus-circle.svg'
import MinusCircleIcon from '../../../../assets/images/hardware-inclusive/minus-circle.svg'
import { getHWPrinterFeatureTranslation, getSelectPrinterHeaderTranslation } from '../../../../utils/HardwareInclusive/HardwareInclusive';

const DisplayPrinterType = (props) => {
    const {
        printerTypeId,
        moveToCustomizePrinter,
        printerName,
        printerInfo,
        printerDescription,
        planStartingPrice,
        dueTodayPrice,
        deviceImg,
        printerFeatures,
        isPrinterStocksAvailable,
        hardwareFeatureFlags,
        isExpanded,
        onToggle
    } = props
    
    return (
        <div className='hardware-printer-type-wrapper'>
            <div className="mobile-header" onClick={onToggle}>
                <div className='printer-name'>
                    {getSelectPrinterHeaderTranslation(printerTypeId, hardwareFeatureFlags)}
                    <div className='mobile-toggle-icon mobile-info'>
                        <div className='info'>{printerInfo}</div>
                    </div>
                </div>
                <span className="mobile-toggle-icon">
                    {isExpanded ?
                        <img src={MinusCircleIcon} alt="printer" />
                        :
                        <img src={PlusCircleIcon} alt="printer" />
                    }
                </span>
            </div>

            <div className={`printer-card-body ${isExpanded ? "expanded" : ""}`}>
                <div className='hardware-print-img-wrapper'>
                    <img src={deviceImg} alt="printer" />
                </div>
                <div className='starting-from-content'>
                    <div className='starting-from'>{t("HARDWARE_SIGNUP.CHOOSE_PRINTER_TYPE.STARTING_FROM")}</div>
                    <div className='starting-from-price'>{dueTodayPrice}</div>
                    <div className='plan-initial-payment'>{t("HARDWARE_SIGNUP.CHOOSE_PRINTER_TYPE.PLAN_REQUIRE_INITIAL_PAYMENT", {planStartingPrice: planStartingPrice})}</div>
                </div>

                <div className='printer-description-wrapper'>
                    <div className='info'>{printerInfo}</div>
                    <div className='description'>{printerDescription}</div>
                    <div className='available-options-wrapper'>
                        <div className='available-options'>{t("HARDWARE_SIGNUP.CHOOSE_PRINTER_TYPE.AVAILABLE_OPTION")}:</div>
                        <div className='available-options-list'>
                            {(hardwareFeatureFlags?.isHWOnly) ? 
                            <>
                            <li>
                                {t(
                                "HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.HARDWARE_TYPE.REFURBISHED.PRINT"
                                )}
                            </li>

                            <li>
                                {t(
                                "HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.HARDWARE_TYPE.REFURBISHED.SCAN"
                                )}
                            </li>

                            <li>
                                {t(
                                "HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.HARDWARE_TYPE.REFURBISHED.COPY"
                                )}
                            </li>
                            </>
                            :
                            printerFeatures
                            ?.sort((a, b) => a?.sortOrder - b?.sortOrder)
                            ?.map(printerFeature => (
                                <li key={printerFeature?.featureId} id={printerFeature?.featureId}>
                                    {getHWPrinterFeatureTranslation(printerFeature?.featureId, printerFeature?.featureName, null, hardwareFeatureFlags)}
                                </li>
                            ))
                            }                 
                        </div>
                    </div>
                </div>
                {(isPrinterStocksAvailable)
                    ? <button
                        className='hardware-inclusive-printer-btn'
                        id={printerName}
                        onClick={() => moveToCustomizePrinter(printerName)}
                    >
                        {t("HARDWARE_SIGNUP.CHOOSE_PRINTER_TYPE.SELECT")}
                    </button>
                    : <div className="no-stock">{t("HARDWARE_SIGNUP.CHOOSE_PRINTER_TYPE.NO_STOCK_AVAILABLE")}</div>
                }
            </div>
        </div>
    );
};

export default DisplayPrinterType;